import * as types from "../actions/ActionTypes.js";

export const getInitialState = () => (
    {
        verificationEmailSent: false,
        verificationEmailSending: false
    });

const ProfileReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.BEGIN_AJAX_CALL:
        return { ...state, verificationEmailSending: true };
    case types.END_AJAX_CALL:
        return { ...state, verificationEmailSending: false };
    case types.CURRENT_USER_VERIFICATION_EMAIL_RESENT:
        return { ...state, verificationEmailSent: true };
    case types.GET_NABP_ROLES_SUCCEEDED:
        return { ...state, nabpRoles: action.nabpRoles};
    default:
        return state;
    }
};

export default ProfileReducer;
